module.exports = __webpack_public_path__ + "static/assets/1add536c12462f72ecd69db660221d3c.svg";